import type {Component, StaticSearchParams} from 'src/typings';
import KpSearchPage from './KpSearchPage.svelte';

interface KpSearchPageComponentBindings {
    staticParams?: Partial<StaticSearchParams>;
}

/**
 * @deprecated IMPORTANT: this is just temporary component for svelte-angular integration
 */
export class KpSearchPageComponent implements Component<KpSearchPageComponentBindings> {
    public static componentName = 'kpSearchPage';

    public bindings = {
        staticParams: '<?'
    } as const;
    public controller = KpSearchPageComponentController;
    public templateUrl = require('./kp-search-page.tpl.ftl');
}

class KpSearchPageComponentController implements KpSearchPageComponentBindings {
    public kpSearchPage = KpSearchPage;
    public staticParams: Partial<StaticSearchParams>;
}